import React, { useContext } from "react";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";
import { BookingContext } from "app/OurService/Booking/Context";
import { ChipGroup } from "components/Form/Field";
import { getDeviceIcon } from "constants/devices";
import { useReferences } from "hooks/reference";

const TroubleshootingFields: React.FC = () => {
    const intl = useContext(IntlContext);
    const booking = useContext(BookingContext);
    const service = booking.getService();
    const reference = useReferences();

    if (
        [SubCategory.TROUBLESHOOTING].includes(booking.getBooking()?.subcategory as SubCategory) &&
        service?.data.device_type !== undefined
    ) {
        return (
            <div className="margin-top--4">
                <ChipGroup
                    inputProps={{
                        name: "data.device_type",
                        required: true,
                        options: service.data.device_type.map((device) => {
                            return {
                                label: reference.get("device", device)?.value ?? device,
                                value: device,
                                Icon: getDeviceIcon(device),
                            };
                        }),
                    }}
                    labelProps={{
                        label: intl.formatMessage("service.label.device_type"),
                    }}
                />
            </div>
        );
    }

    return <></>;
};

export default TroubleshootingFields;
